// src/components/Map/MarkerManager/index.tsx

import React from "react";
import "./index.css";
import TrapMarker from "./Marker";
import { MarkerData } from "../../../types/components/map";
import { useTooltipTransformFix } from "./useTooltipTransformFix";

const MarkerManager: React.FC<{
  markersData?: MarkerData[];
  isLoading: boolean;
}> = ({ markersData = [], isLoading = true }) => {
  useTooltipTransformFix();

  if (isLoading || markersData.length === 0) return null;

  return (
    <>
      {markersData.map((marker) => (
        <TrapMarker marker={marker} key={marker.id ?? marker.displayName} />
      ))}
    </>
  );
};

export default MarkerManager;
